import {
  Grid as MuiGrid,
  Chip as MuiChip,
  Link as MuiLink,
  Typography as MuiTypography,
} from "@mui/material";
import {
  Language as MuiLanguageIcon,
  OpenInNew as MuiOpenInNewIcon,
} from "@mui/icons-material";
import InfoCard from "./InfoCard";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ListingStatusCard = ({ studyListingStatus, nctId, isPublishable }) => {
  const { t } = useTranslation();
  return (
    <InfoCard
      title={"Clinical Trials Directory"}
      titleVariant="small"
      iconComponent={MuiLanguageIcon}
    >
      <MuiGrid container spacing={1} alignItems="center" sx={{ width: "100%" }}>
        <MuiGrid size={{ xs: 12, md: 6 }}>
          <MuiTypography>
            {t("studyInsights.stanfordListingStatus")}:
          </MuiTypography>
        </MuiGrid>
        <MuiGrid
          size={{ xs: 12, md: 6 }}
          sx={{ marginLeft: "auto", textAlign: "right" }}
        >
          {!isPublishable && (
            <MuiChip
              label="Inactive"
              color="warning"
              sx={{ minWidth: "120px" }}
            />
          )}
          {isPublishable && studyListingStatus === "ACTIVE" && (
            <MuiChip
              label="Active"
              color="success"
              sx={{ minWidth: "120px" }}
            />
          )}
          {isPublishable && studyListingStatus === "INACTIVE" && (
            <MuiChip
              label="Inactive"
              color="warning"
              sx={{ minWidth: "120px" }}
            />
          )}
          {isPublishable && studyListingStatus === "WITHDRAWN" && (
            <MuiChip
              label="Withdrawn"
              color="warning"
              sx={{ minWidth: "120px" }}
            />
          )}
        </MuiGrid>
      </MuiGrid>

      {isPublishable && (
        <>
          <MuiTypography mt={3} fontWeight={600}>
            {t("studyInsights.studyListingLocations")}
          </MuiTypography>

          <MuiTypography>
            <MuiLink
              href={`https://aemqa.med.stanford.edu/clinicaltrials/trials/${nctId}`}
              target="_blank"
              color="primary"
            >
              clinicaltrials.stanford.edu{" "}
              <MuiOpenInNewIcon
                fontSize="inherit"
                sx={{ ml: "3px", mb: "-3px" }}
              />
            </MuiLink>
            <br />
            <MuiLink
              href={`https://aemqa.stanfordhealthcare.org/application/ct.html/${nctId}`}
              target="_blank"
              color="primary"
            >
              stanfordhealthcare.org{" "}
              <MuiOpenInNewIcon
                fontSize="inherit"
                sx={{ ml: "3px", mb: "-3px" }}
              />
            </MuiLink>
          </MuiTypography>
        </>
      )}
    </InfoCard>
  );
};

ListingStatusCard.propTypes = {
  studyListingStatus: PropTypes.string.isRequired,
  nctId: PropTypes.string,
  isPublishable: PropTypes.bool.isRequired,
};

export default ListingStatusCard;
